import UploadCircleIcon from '../../../assets/svg/upload-circle.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJImageUploadWidthHistory.module.less';
import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../config/dataConfig/FJGenerateData';
import classNames from 'classnames';
import FJConstant from '../../../constants/FJConstant';
import UploadBorder80Icon from '../../../assets/svg/upload-border-80.svg?react';
import UploadBorder80HoverIcon from '../../../assets/svg/upload-border-80-hover.svg?react';
import FJUtil from '../../../util/FJUtil';
import FJLoading from '../../components/FJLoading/FJLoading.jsx';
import FJImageInput from '../../components/FJImageInput/FJImageInput.jsx';

const EmptyComponent = props => {
    const currentTag = useRef(FJLocalStore.currentTag());
    const { children, onClick } = props;
    const uploadRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            const spanDom = uploadRef.current?.getElementsByTagName('span')[0];
            if (spanDom) {
                spanDom.addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClick();
                });
            }
        }, 500);
        currentTag.current = FJLocalStore.currentTag();
    }, [uploadRef.current, currentTag.current]);

    return (
        <>
            <UploadCircleIcon className={styles.upload_icon} />
            <div
                className={styles.upload_text}
                dangerouslySetInnerHTML={{
                    __html: FJLocalStore._('upload-image-or-choose-from-AI-image'),
                }}
                ref={uploadRef}
            />
            {children}
        </>
    );
};

const FJImageUploadWidthHistory = props => {
    const {
        uploadImg,
        uploadStatus = FJConstant.DEFAULT,
        isSmallComponent = false,
        originImage = {},
        isDraggingFile,
        setIsDraggingFile,
        showAIImageHistoryList,
        onDelete,
        fileType,
        openMediaLibrary,
    } = props;
    const inputRef = useRef(null);
    const _onUploadImg = e => {
        const file = e.target.files[0];
        uploadImg(file);
        e.target.value = null;
    };
    const _onUpload = async e => {
        e.stopPropagation();
        if (!FJUtil.isLogin()) {
            FJUtil.login();
            return;
        }
        if (uploadStatus === FJConstant.LOADING) {
            return;
        }
        if (window.isEditPage && openMediaLibrary) {
            openMediaLibrary();
        } else if (inputRef.current) {
            inputRef.current.click();
        }
    };
    const _onDragOver = e => {
        setIsDraggingFile(true);
        e.stopPropagation();
        e.preventDefault();
    };

    const _onDragLeave = e => {
        setIsDraggingFile(false);
        e.stopPropagation();
        e.preventDefault();
    };

    const _onDragDrop = e => {
        setIsDraggingFile(false);
        e.stopPropagation();
        e.preventDefault();
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            uploadImg(file);
        }
    };
    const _onDelete = () => {
        onDelete();
    };

    const renderEmptyUpload = () => {
        return <EmptyComponent onClick={showAIImageHistoryList}>{renderBorder()}</EmptyComponent>;
    };

    const renderBorder = () => {
        return (
            <div className={styles.upload_border_box}>
                <UploadBorder80Icon className={styles.upload_border} />
                <UploadBorder80HoverIcon className={styles.upload_border_hover} />
            </div>
        );
    };
    const renderSuccess = () => {
        return (
            <FJImageInput
                uploadImageInfo={originImage}
                isDraggingFile={isDraggingFile}
                isDelete={true}
                onDelete={_onDelete}
                acceptFile={fileType || UPLOAD_FILE_TYPE_NO_GIF}
                openMediaLibrary={openMediaLibrary}
                setIsDraggingFile={setIsDraggingFile}
                uploadImg={uploadImg}
                style={{ height: 80 }}
            />
        );
    };

    const renderGenerating = () => {
        return (
            <>
                <div className={styles.preview_box}>
                    <div className={styles.loading}>
                        <FJLoading strokeColor='#A8ACBC' />
                    </div>
                </div>
                {renderBorder()}
            </>
        );
    };
    const renderMain = () => {
        switch (uploadStatus) {
            case FJConstant.DEFAULT:
                return renderEmptyUpload();
            case FJConstant.SUCCESS:
                return renderSuccess();
            default:
                return renderGenerating();
        }
    };

    return (
        <div
            className={classNames(
                styles.box,
                isDraggingFile && styles.dragging,
                isSmallComponent && styles.small,
                uploadStatus === FJConstant.SUCCESS && styles.success,
            )}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
            onClick={uploadStatus === FJConstant.SUCCESS ? null : _onUpload}
        >
            {renderMain()}
            <input
                type='file'
                ref={inputRef}
                accept={fileType || UPLOAD_FILE_TYPE_NO_GIF}
                className={styles.input}
                onChange={_onUploadImg}
            />
        </div>
    );
};

FJImageUploadWidthHistory.propTypes = {
    openMediaLibrary: PropTypes.func,
    uploadImg: PropTypes.func,
    isLoading: PropTypes.bool,
    isUploading: PropTypes.bool,
    uploadStatus: PropTypes.string,
    isSmallComponent: PropTypes.bool,
    originImage: PropTypes.object,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
};

export default FJImageUploadWidthHistory;
